import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class PreventiveMaintenanceSummaryService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) { }

    getSummary(arranging, confirmed, completed, cancelled, startDate, endDate, all, customerId): Observable<any> {
        let url;
        let prefix;
        if (all) {
            prefix = 'pms?';
        } else {
            prefix = 'customers/' + customerId + '/pm-summary?';
        }
        url = this.urlPrefix + prefix + 'start-date=' + startDate + '&end-date=' + endDate
        + '&arranging=' + arranging + '&confirmed=' + confirmed + '&completed=' + completed + '&cancelled=' + cancelled ;

        return this.httpClient
            .get(url,
                {
                    observe: 'response'
                })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-summary/preventive-maintenance-summary.service.ts